import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, provide, ref, watch } from "vue";
import { useAuthStore } from "@/store/AuthModule";
import HeaderComponentVue from "./components/common/HeaderComponent.vue";
import ModalComponentVue from "./components/common/ModalComponent.vue";
import { msalInstance } from "./app.config";
import {
  BrowserAuthError,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const interval = ref();
const account = ref();

const authStore = useAuthStore();
const router = useRoute();

const refreshTime = computed(() => {
  return authStore.refreshTime;
});

const token = computed(() => {
  return authStore.token;
});

const totalTime = ref(refreshTime.value);

async function refreshToken(): Promise<void> {
  let accs = msalInstance.getAllAccounts();
  if (accs.length > 0) {
    account.value = accs[0];
  }

  let silentRequest = {
    scopes: ["api://SOBI/read"],
    account: account.value,
    forceRefresh: false,
  };

  let loginRequest = {
    scopes: ["api://SOBI/read"],
    account: account.value,
    prompt: "select_account",
  };

  let tokenResponse = await msalInstance
    .acquireTokenSilent(silentRequest)
    .catch((error) => {
      if (error instanceof (InteractionRequiredAuthError || BrowserAuthError)) {
        return msalInstance.acquireTokenRedirect(loginRequest);
      }
    });

  //eslint-disable-next-line
  //@ts-ignore
  authStore.setToken(tokenResponse.accessToken);
}

function setIntervalForRefresh(): void {
  interval.value = setInterval(() => {
    totalTime.value--;
    authStore.setRefreshTime(totalTime.value);
  }, 1000);
}

function clearIntervalRefresh() {
  clearInterval(interval.value);
}

watch(
  token,
  () => {
    if (token.value !== null && token.value !== "") {
      if (refreshTime.value === 0) {
        authStore.setRefreshTime(3600);
        totalTime.value = authStore.refreshTime;
        setIntervalForRefresh();
      }
    } else {
      authStore.setRefreshTime(0);
      totalTime.value = authStore.refreshTime;
      clearIntervalRefresh(); 
    }
  },
  { immediate: true }
);

watch(
  refreshTime,
  async () => {
    if (refreshTime.value === 0) {
      await refreshToken();
      clearIntervalRefresh();
      authStore.setRefreshTime(100);
      totalTime.value = authStore.refreshTime;
      setIntervalForRefresh();
    }
  },
  { immediate: true }
);

onMounted(() => {
  clearIntervalRefresh();

  if (refreshTime.value > 0) {
    totalTime.value = refreshTime.value;
    setIntervalForRefresh();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.$route.name === 'login' ? 'login-background' : 'background-wrapper',
      _ctx.$route.name !== 'admin' ? 'user-background' : 'admin-background',
    ])
  }, [
    (_ctx.$route.path !== '/')
      ? (_openBlock(), _createBlock(HeaderComponentVue, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ModalComponentVue),
    _createVNode(_component_router_view)
  ], 2))
}
}

})